/* @flow */

export default function Render(props: { when: boolean, children: React.Node }) {
  if (props.when) {
    return props.children;
  } else {
    return null;
  }
}
